import request from '@/utils/request'

export function getNotifications(branchId, size, page, find, dates, dateType, id, readTitle, featureFlag, notifiedAtSort) {
  return request({
    url: `/serviceNotifications/notifications/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      startDate: dates,
      dateType: dateType,
      readTitle: readTitle,
      featureFlag: featureFlag,
      id: id,
      notifiedAtSort: notifiedAtSort
    }
  })
}

export function readNotification(branchId, notificationId, readId, data) {
  return request({
    url: `/serviceNotifications/notifications/read/${branchId}/${notificationId}/${readId}`,
    method: 'put',
    data
  })
}

export function getUnreadNotifications(branchId) {
  return request({
    url: `/serviceNotifications/notifications/unread/${branchId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/serviceNotifications.js